import { useTranslation } from 'react-i18next';
import { Box, Button, Heading, Text } from '@hawkins/components';
import { Dimensions } from '@hawkins/variables';
import { IconWarning } from '@hawkins/assets';
import { useNavigate, useLocation } from 'react-router-dom'

import { TranslationNamespace } from '../types';

export function EmergencyRequestCTA() {
  const { t } = useTranslation(TranslationNamespace.LEP);
  const navigate = useNavigate();
  const state = useLocation().state;
  let userInfo = null;
  if (state && state.userInfo) {
    userInfo = state.userInfo;
  }

  return (
    <>
      <Box alignItems="center" columnGap={Dimensions.Space12} display="flex">
        <IconWarning />
        <Heading level={1}>{t('request_emergency_title')}</Heading>
      </Box>

      <Text gutterBottom={Dimensions.Space16} gutterTop={Dimensions.Space8}>
        {t("request_emergency_instructions")}
      </Text>

      <Box display="flex" justifyContent="flex-end">
        <Button
          variant='primary-destructive'
          style={{ color: 'white' }}
          onClick={() => navigate('/emergency', { state: { userInfo } })}
        >
          {t('button2')}
        </Button>
      </Box>
    </>
  );
}
